import { render, staticRenderFns } from "./crumbs.vue?vue&type=template&id=5a375e9a&scoped=true&"
import script from "./crumbs.vue?vue&type=script&lang=js&"
export * from "./crumbs.vue?vue&type=script&lang=js&"
import style0 from "./crumbs.vue?vue&type=style&index=0&id=5a375e9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a375e9a",
  null
  
)

export default component.exports